import axios from "axios";
import router from "@/router/index.js";
import { ElMessage } from 'element-plus'
import store from '@/store/index.js'

//创建axios的实例instance
const instance = axios.create({
    // 开发环境
    // baseURL: "http://localhost:6004",
    // 生产环境
    baseURL: "https://www.gdstinfo.cn/api",
    timeout: 60000,
})

// 添加请求拦截器
instance.interceptors.request.use(
    function (config) {
        const token = store.state.user.token
        if (token) {
            config.headers.token = token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
instance.interceptors.response.use(
    function (response) {
        if (response.data.code == 10004) {
            ElMessage.warning({
                message: 'Login has expired, please log in again',
                type: 'warning',
            })
            localStorage.removeItem("conferenceStore")
            store.commit("setUser", {})
            router.push("/login")
        }
        else if(response.data.code == 63200){
            ElMessage.warning({
                message: 'Illegal user access, do not attempt multiple times as it may result in your account being banned',
                type: 'warning',
            })
        }
        return response.data;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default instance;




